import { render, staticRenderFns } from "./PersonalCaseAddBankModal.vue?vue&type=template&id=3147969e"
import script from "./PersonalCaseAddBankModal.vue?vue&type=script&lang=js"
export * from "./PersonalCaseAddBankModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports